exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".settings[data-v-4d2a1a6a] {\n  overflow: auto !important;\n}\n.settings[data-v-4d2a1a6a] .preferences {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 12px 4px;\n}\n.settings[data-v-4d2a1a6a] .preferences > * {\n  flex-basis: 380px;\n  margin: 16px 24px;\n}\n.settings[data-v-4d2a1a6a] .preferences .vue-ui-form-field > .wrapper > .content {\n  min-height: 32px;\n  justify-content: center;\n}\n", ""]);

// exports
